import { combineReducers } from 'redux';
import {
  AssessmentRiskAnalysisActionTypes,
  AssessmentRiskAnalysisState,
  ASSESSMENT_LOAD_RISK_ANALYSIS_ERROR,
  ASSESSMENT_LOAD_RISK_ANALYSIS_REQUEST,
  ASSESSMENT_LOAD_RISK_ANALYSIS_SUCCESS,
  ASSESSMENT_LOAD_FORMS_STATUS_REQUEST,
  ASSESSMENT_LOAD_FORMS_STATUS_SUCCESS,
  ASSESSMENT_COMPLETE_BLOCKED,
  ASSESSMENT_COMPLETE_BLOCKED_DISMISS,
  AssessmentActionTypes,
  FormsStatusIndexedItem,
  OpenFormSummary,
  Loader,
  SelectedAssessment,
} from '../types';

const loaderInitialState: Loader = {
  loading: false,
  success: false,
  error: '',
  completed: false,
};

const assessmentRiskAnalysisInitialState: AssessmentRiskAnalysisState = {
  forms: {},
  answers: {},
  assessmentTotalRisks: 0,
};

export const assessmentRiskAnalysisReducer = (
  state = assessmentRiskAnalysisInitialState,
  action: AssessmentRiskAnalysisActionTypes,
): AssessmentRiskAnalysisState => {
  switch (action.type) {
    case ASSESSMENT_LOAD_RISK_ANALYSIS_REQUEST: {
      return state;
    }
    case ASSESSMENT_LOAD_RISK_ANALYSIS_SUCCESS: {
      return { ...action.assessmentRiskAnalysis };
    }
    case ASSESSMENT_LOAD_RISK_ANALYSIS_ERROR: {
      return state;
    }
    default: {
      return state;
    }
  }
};

export const loaderReducer = (
  state: Loader = loaderInitialState,
  action: AssessmentRiskAnalysisActionTypes,
): Loader => {
  switch (action.type) {
    case ASSESSMENT_LOAD_RISK_ANALYSIS_SUCCESS: {
      return {
        ...state,
        completed: true,
        success: true,
        loading: false,
      };
    }
    case ASSESSMENT_LOAD_RISK_ANALYSIS_REQUEST: {
      return {
        ...state,
        loading: true,
        completed: false,
      };
    }
    case ASSESSMENT_LOAD_RISK_ANALYSIS_ERROR: {
      return {
        ...state,
        loading: false,
        completed: true,
        error: state.error,
      };
    }
    default: {
      return state;
    }
  }
};

export const formsStatusReducer = (
  state: FormsStatusIndexedItem = {},
  action: AssessmentActionTypes,
): FormsStatusIndexedItem => {
  switch (action.type) {
    case ASSESSMENT_LOAD_FORMS_STATUS_REQUEST: {
      return {};
    }
    case ASSESSMENT_LOAD_FORMS_STATUS_SUCCESS: {
      return action.formsStatus.reduce<FormsStatusIndexedItem>((acc, f) => {
        acc[f.formId] = f;
        return acc;
      }, {});
    }
    default: {
      return state;
    }
  }
};

export const blockedSubmitReducer = (
  state: OpenFormSummary[] | null = null,
  action: AssessmentActionTypes,
): OpenFormSummary[] | null => {
  switch (action.type) {
    case ASSESSMENT_COMPLETE_BLOCKED: {
      return action.openForms;
    }
    case ASSESSMENT_COMPLETE_BLOCKED_DISMISS: {
      return null;
    }
    default: {
      return state;
    }
  }
};

export const combinedAssessmentReducer = combineReducers<SelectedAssessment>({
  risksAnalysis: assessmentRiskAnalysisReducer,
  loader: loaderReducer,
  formsStatus: formsStatusReducer,
  blockedSubmit: blockedSubmitReducer,
});
